import InfoLink from "./InputInfolink";
export default InfoLink;
